"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNumericPinDesignator = isNumericPinDesignator;
exports.usesLabelledPinDesignators = usesLabelledPinDesignators;
exports.collectUniqueAssignedPinDesignators = collectUniqueAssignedPinDesignators;
exports.countUniqueAssignedPinDesignators = countUniqueAssignedPinDesignators;
exports.collectUniqueAssignedPackageSignalPinDesignators = collectUniqueAssignedPackageSignalPinDesignators;
exports.countUniqueAssignedPackageSignalPinDesignators = countUniqueAssignedPackageSignalPinDesignators;
exports.collectUniqueAssignedFormPinDesignators = collectUniqueAssignedFormPinDesignators;
exports.countUniqueAssignedFormPinDesignators = countUniqueAssignedFormPinDesignators;
exports.findOutOfRangePinDesignators = findOutOfRangePinDesignators;
exports.formatOutOfRangePinError = formatOutOfRangePinError;
exports.formatPinCountMismatchError = formatPinCountMismatchError;
exports.formatUnmappedTerminalMessage = formatUnmappedTerminalMessage;
exports.formatUnmappedSignalPinoutError = formatUnmappedSignalPinoutError;
const pin_count_rules_1 = require("./pin-count-rules");
function isNumericPinDesignator(designator) {
    return /^\d+$/.test(designator.trim());
}
function usesLabelledPinDesignators(designators) {
    for (const designator of designators) {
        if (designator.trim() !== '' && !isNumericPinDesignator(designator)) {
            return true;
        }
    }
    return false;
}
function isActiveModelSignalForPinCount(modelSignal, pinout) {
    if (!modelSignal.isOptional) {
        return true;
    }
    return (0, pin_count_rules_1.normalizePinDesignators)(pinout[String(modelSignal.id)] ?? []).length > 0;
}
function collectUniqueAssignedPinDesignators(modelSignals, pinout, ncPinNumbers = []) {
    const uniquePins = new Set();
    for (const modelSignal of modelSignals) {
        if (!isActiveModelSignalForPinCount(modelSignal, pinout)) {
            continue;
        }
        for (const pin of (0, pin_count_rules_1.normalizePinDesignators)(pinout[String(modelSignal.id)] ?? [])) {
            uniquePins.add(pin);
        }
    }
    for (const pin of (0, pin_count_rules_1.normalizePinDesignators)(ncPinNumbers)) {
        uniquePins.add(pin);
    }
    return uniquePins;
}
function countUniqueAssignedPinDesignators(modelSignals, pinout, ncPinNumbers = []) {
    return collectUniqueAssignedPinDesignators(modelSignals, pinout, ncPinNumbers).size;
}
function collectUniqueAssignedPackageSignalPinDesignators(packageSignals, pinout, ncPinNumbers = []) {
    const uniquePins = new Set();
    for (const signal of packageSignals) {
        for (const pin of (0, pin_count_rules_1.normalizePinDesignators)(pinout[String(signal.id)] ?? [])) {
            uniquePins.add(pin);
        }
    }
    for (const pin of (0, pin_count_rules_1.normalizePinDesignators)(ncPinNumbers)) {
        uniquePins.add(pin);
    }
    return uniquePins;
}
function countUniqueAssignedPackageSignalPinDesignators(packageSignals, pinout, ncPinNumbers = []) {
    return collectUniqueAssignedPackageSignalPinDesignators(packageSignals, pinout, ncPinNumbers).size;
}
function collectUniqueAssignedFormPinDesignators(modelSignals, packageSignals, pinout, ncPinNumbers = []) {
    return new Set([
        ...collectUniqueAssignedPinDesignators(modelSignals, pinout, ncPinNumbers),
        ...collectUniqueAssignedPackageSignalPinDesignators(packageSignals, pinout, ncPinNumbers),
    ]);
}
function countUniqueAssignedFormPinDesignators(modelSignals, packageSignals, pinout, ncPinNumbers = []) {
    return collectUniqueAssignedFormPinDesignators(modelSignals, packageSignals, pinout, ncPinNumbers).size;
}
function findOutOfRangePinDesignators(assignedPins, pinCount) {
    const outOfRange = [];
    for (const pin of assignedPins) {
        if (!isNumericPinDesignator(pin)) {
            outOfRange.push(pin);
            continue;
        }
        const value = Number.parseInt(pin, 10);
        if (value < 1 || value > pinCount) {
            outOfRange.push(pin);
        }
    }
    return outOfRange.sort((a, b) => a.localeCompare(b, undefined, { numeric: true }));
}
function formatOutOfRangePinError(outOfRangePins, pinCount) {
    const pinWord = outOfRangePins.length === 1 ? 'pin' : 'pins';
    return `Remove or correct ${pinWord} ${outOfRangePins.join(', ')} — this package only has pins 1–${pinCount}.`;
}
function formatPinCountMismatchError(pinCount, assignedPinCount) {
    if (assignedPinCount === 0) {
        return `Assign all pins to a signal or no connect. This package has ${pinCount} pins — none are assigned yet.`;
    }
    if (assignedPinCount < pinCount) {
        const stillMissing = pinCount - assignedPinCount;
        const missingWord = stillMissing === 1 ? 'pin' : 'pins';
        return (`Assign all pins to a signal or no connect. This package has ${pinCount} pins — ` +
            `only ${assignedPinCount} assigned, ${stillMissing} ${missingWord} still missing.`);
    }
    return (`This package has ${pinCount} pins, but ${assignedPinCount} distinct pin numbers are assigned. ` +
        `Remove the extra pins, or fix any that fall outside 1–${pinCount}.`);
}
function formatUnmappedTerminalMessage(elementId, terminalName) {
    if (elementId !== null) {
        return `Array element ${elementId}: assign a pin to terminal "${terminalName}".`;
    }
    return `Required signal "${terminalName}" has no pin numbers assigned.`;
}
function formatUnmappedSignalPinoutError(signalName, arraySubmit) {
    if (arraySubmit) {
        const arrayElementMatch = /^([A-Z]+\d+)_(.+)$/.exec(signalName);
        const elementId = arrayElementMatch?.[1];
        const terminalName = arrayElementMatch?.[2];
        if (elementId !== undefined && terminalName !== undefined) {
            return formatUnmappedTerminalMessage(elementId, terminalName);
        }
    }
    return formatUnmappedTerminalMessage(null, signalName);
}
//# sourceMappingURL=pin-designator-rules.js.map